export default __webpack_public_path__ + "static/media/element_spec_74.0ef75345.webp";